import { Card } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { CSSProperties, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import KanseiBreadcrumbs from 'components/breadcrumb'
import { cls1Api } from 'hooks/api/cls1'
import { companyApi } from 'hooks/api/company'
import { Company } from 'types/company'
import { CompanyBranch } from 'types/companyBranch'

export function CompanyBranchDetailPage() {
  const [company, setCompany] = useState<Company>()
  const [branch, setBranch] = useState<CompanyBranch>()
  const [securityFile, setSecurityFile] = useState<File>()
  const [securityFieldFile, setSecurityFieldFile] = useState<File>()
  const { id } = useParams<{ id: string }>()
  const { branchId } = useParams<{ branchId: string }>()

  const fetchData = () => {
    companyApi()
      .findById(id!)
      .then((res) => {
        setCompany(res.data)

        res.data.companyBranches?.find((branch) => {
          if (branch.id === branchId) {
            setBranch(branch)
            return true
          }
          return false
        })
      })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const links = [
    {
      title: '警備会社一覧',
      to: '/cls1/company',
    },
    {
      title: company ? company.name : '',
      to: `/cls1/company/${id}/branch`,
    },
    {
      title: branch ? branch.branchName : '',
    },
  ]

  const handleSecurityFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSecurityFile(e.target.files[0])
    }
  }

  const handleSecurityFieldFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (e.target.files && e.target.files[0]) {
      setSecurityFieldFile(e.target.files[0])
    }
  }

  const handleSecurityFileUpload = () => {
    if (!securityFile) return

    const formData = new FormData()
    formData.append('file', securityFile!)

    if (branchId == null || branchId === '') {
      alert('何かおかしいです (branchId)')
      return
    }

    cls1Api()
      .securityCsvImport(branchId, formData)
      .catch((err) => {
        alert(`エラー(スクショお願いします): ${JSON.stringify(err)}`)
        throw err
      })
      .then(() => {
        alert('取り込まれました')
      })
  }

  const handleSecurityFieldFileUpload = () => {
    if (!securityFieldFile) return

    const formData = new FormData()
    formData.append('file', securityFieldFile!)

    if (branchId == null || branchId === '') {
      alert('何かおかしいです (branchId)')
      return
    }

    cls1Api()
      .securityFieldCsvImport(branchId, formData)
      .catch((err) => {
        alert(`エラー(スクショお願いします): ${JSON.stringify(err)}`)
        throw err
      })
      .then(() => {
        alert('取り込まれました')
      })
  }

  return (
    <Box>
      <KanseiBreadcrumbs links={links} style={{ marginBottom: '15px' }} />
      <Box style={containerStyle}>
        <Card style={cardStyle}>
          <h3>支店名 : {branch?.branchName}</h3>
          CSVで初期データをインポート
          <Box>
            <input
              type="file"
              accept=".csv"
              onChange={handleSecurityFileChange}
            />
            <Button variant="contained" onClick={handleSecurityFileUpload}>
              隊員追加
            </Button>
          </Box>
          <Box>
            <input
              type="file"
              accept=".csv"
              onChange={handleSecurityFieldFileChange}
            />
            <Button variant="contained" onClick={handleSecurityFieldFileUpload}>
              警備先追加
            </Button>
          </Box>
        </Card>
      </Box>
    </Box>
  )
}

const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}

const cardStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '16px',
}
